import { Box, Typography, Dialog, Slide, IconButton, Button } from '@material-ui/core';
import { createStyles, makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import { closeOverlayAndResetPromo } from '../redux/UIOverlayPersonalSizeRedux';
import { useAppDispatch, useAppSelector } from '../reduxhooks';
import { openOverlayCreateMeasWithInitialization } from '../redux/UIOverlayMeasurementMethodSelectionViewRedux';
import { openOverlayCreateMeasWithInitialization as openUniversalSizeOverlay } from '../redux/UIOverlayUniversalSizeRedux';
import { sendWebsiteEventMessage } from '../telegrambotevents';
import OverlayComponentButton from './OverlayComponentButton';
import { UIOverlayViewStatus } from 'common-ts/dist/models/UIOverlayViewStatus';
import React from 'react';
import { TransitionProps } from '@material-ui/core/transitions';
import { Close } from '@material-ui/icons';
import { Player } from '@lottiefiles/react-lottie-player';
import { StarWarsNameCard } from './OverlayViewUniversalSize0BenefitStart';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogContainer: {
      zIndex: ((theme.zIndex.modal + 1) + " !important") as any,
      '& .MuiPaper-root': {
        width: "90vw",
        borderRadius: "5.4vw",
        // backgroundColor: "#090F17"
      },
      '& .MuiBackdrop-root': {
        backgroundColor: "rgba(0, 0, 0, 0.7)"
      } 
    },
    dialogContentContainer: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '20px 0px 0px',
      // textAlign: 'center',
    },
    dialogDivImage: {
      width: "100%",
      // height: "124vw",
      overflow: "hidden",
      position: "relative",
      // backgroundColor: "#090F17",
    },
    backButton: {
      position: 'absolute',
      top: theme.spacing(3),
      right: theme.spacing(2),
      backgroundColor: 'black',
      borderRadius: '50%',
      padding: theme.spacing(1),
    },
    backButtonIcon: {
      padding: '0',
      color: 'white',
    },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      overflowY: 'hidden',
    },
    pageTitleHeader: {
      fontSize: '0.3em',
      letterSpacing: '0.05em',
      color: 'rgb(85, 85, 85)',
      fontWeight: 300,
    },
    pageTitle: {
      marginTop: '10px',
      fontSize: '1.2em',
      // width: '100%',
      fontWeight: 550,
    },
    pageItem: {
      display: 'grid',
      gridTemplateColumns: '1fr 8fr',
      marginTop: '1em',
    },
    pageItemIcon: {
      marginRight: '0.2em',
    },
    pageItemTitle: {
      paddingTop: '0.2em',
      fontSize: '0.8em',
      fontWeight: 500,
    },
    pageItemDescription: {
      gridColumn: '2',
      paddingTop: '0.2em',
      paddingRight: '0.5em',
      fontSize: '0.1em',
    },
  }),
);

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} timeout={170} />;
});
  

interface Props {
}

export default function OverlayView({}: Props) {
  const overlayView = useAppSelector(state => state.overlayPersonalSize);
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const firstName = useAppSelector(state => state.account.name?.split(' ')?.[0] ?? 'Fariz');

  function handleClose() {
    dispatch(closeOverlayAndResetPromo());
    sendWebsiteEventMessage("[PERSONAL FIT] User closed personal size promo popup");
  }

  return (
    <Dialog
      open={overlayView.statusPromo === UIOverlayViewStatus.On}
      TransitionComponent={Transition}
      // keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      onClose={() => handleClose()}
      className={classes.dialogContainer}>
        <div className={classes.dialogContentContainer}>
          <div className={classes.dialogDivImage}>
            <Box className={classes.dialogContent}>
              <Box style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }} onClick={() => {
                const element = document.getElementById("univ-size-benefit-2");

                if (element) {
                  element.scrollIntoView({behavior: "smooth", block: 'center'});
                }
              }}>
                <Typography style={{
                  fontSize: '11px',
                  color: 'rgb(98,98,98)',
                  marginTop: '10px',
                  letterSpacing: '0.5px'
                }}>
                  PROFIL UKURAN PERSONAL
                </Typography>
                <Typography style={{
                  fontSize: '28px',
                  fontWeight: 600,
                  marginTop: '10px',
                }}>
                  Buat Semua Jadi Pas
                </Typography>
                <Typography style={{
                  fontSize: '9.4px',
                  color: 'rgb(114, 114, 114)',
                  textAlign: 'center',
                  margin: '7px 20px -14px',
                  letterSpacing: '0.1px',
                  fontWeight: 300,
                }}>
                  Dengan Ukuran Personal, semua item yang kamu beli akan<br/> datang dengan pas dan sesuai dengan yang kamu mau.
                </Typography>
                <StarWarsNameCard name={firstName} isOneName={true}/>
              </Box>
              <Box style={{width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '-7px',
              }}>
                <Box style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: '10px'}}>
                  <Button style={{
                    color: '#000000',
                    backgroundColor: 'rgba(100, 100, 100, 0.0)',
                    borderRadius: '30px',
                    border: '1px solid black',
                    padding: '8px 15px 4px 15px',
                    fontSize: '11px',
                    letterSpacing: '0.7px',
                    margin: '10px 23px'
                  }}
                  onClick={() => {
                    handleClose()
                  }}
                  >
                    NANTI DULU
                  </Button>
                  <Button style={{
                    color: 'white',
                    backgroundColor: '#121212',
                    borderRadius: '30px',
                    padding: '8px 15px 4px 15px',
                    fontSize: '11px',
                    letterSpacing: '0.7px',
                    margin: '10px 23px'
                  }}
                  onClick={() => {
                      dispatch(closeOverlayAndResetPromo());
                      dispatch(openUniversalSizeOverlay({ productOnUser: overlayView.payloadPromo.productDetail, flowVariant: 'default' }));
                      sendWebsiteEventMessage("[PERSONAL FIT] User click mulai");
                  }}
                  >
                    COBA BUAT
                  </Button>
                </Box>
              </Box>
            </Box>
        </div>
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => handleClose()}
            style={{ position: 'absolute', top: '1px', right: '12px' }}
          >
            <Close />
          </IconButton>
      </div>
    </Dialog>);
  
  return (
  <Dialog
    open={overlayView.statusPromo === UIOverlayViewStatus.On}
    TransitionComponent={Transition}
    // keepMounted
    aria-labelledby="alert-dialog-slide-title"
    aria-describedby="alert-dialog-slide-description"
    onClose={() => handleClose()}
    className={classes.dialogContainer}>
      <div className={classes.dialogContentContainer}>
        <div className={classes.dialogDivImage}>
          <Box className={classes.dialogContent}>
            <Typography className={classes.pageTitleHeader} style={{ padding: '0px 18px' }}>
              CAPE BUAT UKURAN LAGI?
            </Typography>
            <Typography className={classes.pageTitle} style={{ padding: '0px 18px',
              textUnderlineOffset: '3px'
             }}>
              <u>Satu Ukuran</u> Personal,<br/>Buat <u>Semua Produk.</u>
            </Typography>
            <Typography className={classes.pageItemDescription} style={{margin: '10px 0px 15px', color: 'rgb(122,122,122)', fontWeight: 300, letterSpacing: '0.1vw', padding: '0px 18px' }}>
              Buat Ukuran Personal kamu di Studio S, dan semua produk yang kamu beli akan datang dengan ukuran yang paling pas buat kamu.
            </Typography>
            <Box style={{
              width: '100%',
              overflow: 'clip',
              margin: '-2px 0px'
            }}>
              <Player
                key='regular-animation'
                autoplay
                loop
                src={'https://studiosclo.uk/general/Size_Card_Demonstration_2.json'}
                style={{
                  width: '116%',
                  marginLeft: '-8%'
                }}
              >
              </Player>
            </Box>
            <Box style={{width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '10px',
              borderTop: '1px solid #d0d0d0',
              backgroundColor: '#f7f7f7',
            }}>
              <Typography style={{
                margin: '18px 0px 9px',
                fontWeight: 300,
                fontSize: '10.5px',
                textUnderlineOffset: '3px',
                letterSpacing: '0.2px',
              }}>Proses ini membutuhkan waktu <span style={{fontWeight: 600}}><i><u>2-3 menit.</u></i></span></Typography>
              <Box style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: '10px'}}>
                <Button style={{
                  color: '#000000',
                  backgroundColor: 'rgba(100, 100, 100, 0.0)',
                  borderRadius: '30px',
                  border: '1px solid black',
                  padding: '8px 15px 4px 15px',
                  fontSize: '11px',
                  letterSpacing: '0.7px',
                  margin: '10px 23px'
                }}
                onClick={() => {
                  handleClose()
                }}
                >
                  NANTI DULU
                </Button>
                <Button style={{
                  color: 'white',
                  backgroundColor: '#121212',
                  borderRadius: '30px',
                  padding: '8px 15px 4px 15px',
                  fontSize: '11px',
                  letterSpacing: '0.7px',
                  margin: '10px 23px'
                }}
                onClick={() => {
                    dispatch(closeOverlayAndResetPromo());
                    dispatch(openUniversalSizeOverlay({ productOnUser: overlayView.payloadPromo.productDetail, flowVariant: 'default' }));
                    sendWebsiteEventMessage("[PERSONAL FIT] User click mulai");
                }}
                >
                  MULAI BUAT
                </Button>
              </Box>
            </Box>
          </Box>
      </div>
        <IconButton
          edge="end"
          color="inherit"
          onClick={() => handleClose()}
          style={{ position: 'absolute', top: '1px', right: '12px' }}
        >
          <Close />
        </IconButton>
    </div>
  </Dialog>);
}